// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getCurrentBaseUrl = (locale: any): string => `${process.env.NEXT_PUBLIC_BASE_URL}/${locale}`;

export default getCurrentBaseUrl;
